// extracted by mini-css-extract-plugin
module.exports = {"imgLogo":"Logo_imgLogo__1iP-M","navLogo":"Logo_navLogo__DDPoF","imgNav":"Logo_imgNav__29ssK"};